import { motion } from 'framer-motion';
import { MapPin, Phone, Mail, Clock } from 'lucide-react';
import { COMPANY } from '../data/site';
import { EnquiryFormFields, EnquirySuccess, useEnquiryForm } from '../components/EnquiryPopup';

const INFO = [
  { icon: Phone, label: 'CALL US', value: COMPANY.phone, href: `tel:${COMPANY.phoneRaw}`, testid: 'enquiry-phone' },
  { icon: Mail, label: 'EMAIL', value: COMPANY.email, href: `mailto:${COMPANY.email}`, testid: 'enquiry-email' },
  { icon: MapPin, label: 'OFFICE', value: COMPANY.address, testid: 'enquiry-address' },
  { icon: Clock, label: 'OFFICE TIMINGS', value: COMPANY.hours, testid: 'enquiry-timings' },
];

export default function Enquiry() {
  const { form, setForm, status, submit } = useEnquiryForm();
  return (
    <main data-testid="enquiry-page" className="pt-40 pb-32 min-h-screen">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <p className="text-[10px] tracking-[0.3em] text-terra font-medium mb-6">WE REPLY WITHIN ONE WORKING DAY</p>
        <motion.h1
          initial={{ opacity: 0, y: 34 }} animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
          className="font-heading font-extrabold tracking-tighter leading-[0.95] text-5xl sm:text-7xl text-ink mb-16"
          data-testid="enquiry-headline"
        >
          Enquiry
        </motion.h1>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-14">
          <div className="lg:col-span-7">
            <motion.div
              initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7, delay: 0.1 }}
              className="bg-stone border border-clay p-8 lg:p-12"
            >
              {status === 'sent' ? (
                <EnquirySuccess />
              ) : (
                <EnquiryFormFields form={form} setForm={setForm} status={status} onSubmit={submit} submitTestid="enquiry-page-submit-btn" formTestid="enquiry-page-form" />
              )}
            </motion.div>
          </div>
          <div className="lg:col-span-5">
            <div className="border-t border-clay">
              {INFO.map((item) => (
                <motion.div
                  key={item.label}
                  initial={{ opacity: 0, y: 16 }} whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }} transition={{ duration: 0.5 }}
                  className="flex gap-5 py-6 border-b border-clay"
                  data-testid={item.testid}
                >
                  <span className="w-10 h-10 bg-terra/10 text-terra flex items-center justify-center shrink-0"><item.icon size={16} /></span>
                  <div>
                    <p className="text-[9px] tracking-[0.26em] text-ink/40 font-medium mb-1.5">{item.label}</p>
                    {item.href ? (
                      <a href={item.href} className="text-sm text-ink font-medium leading-relaxed hover:text-terra transition-colors duration-200">{item.value}</a>
                    ) : (
                      <p className="text-sm text-ink font-medium leading-relaxed">{item.value}</p>
                    )}
                  </div>
                </motion.div>
              ))}
            </div>
            <div className="mt-10 bg-moss text-sand p-8" data-testid="enquiry-side-note">
              <p className="font-heading font-bold text-lg tracking-tight">Prefer to walk in?</p>
              <p className="mt-2 text-sm text-sand/60 leading-relaxed">
                Visit our office any day between {COMPANY.hours}. Bring your questions —
                leave with layout plans, pricing and a site-visit slot.
              </p>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
}
